<template>
  <div class="dialog-container">
    <el-dialog
      v-model="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
      ref="instance"
      width="981"
    >
      <div class="close">
        <img :src="closeImg" alt="" @click="instance.handleClose()" />
      </div>
      <div class="fz">
        <img :src="img" alt="" />
      </div>
      <!-- <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="dialogVisible = false">
                        确认
                    </el-button>
                </div>
            </template> -->
    </el-dialog>
  </div>
</template>

<script setup>
import img from "@/assets/images/web-fz.png";
import closeImg from "@/assets/images/close-icon.png";
import { onMounted } from "vue";
const dayCount = ref(0);
const dialogVisible = defineModel("show", {
  default: false,
});
// 检查是否需要显示弹窗
const checkShouldShowModal = () => {
  const storageKey = "daily-modal-data";
  const today = new Date().toDateString();

  // 从 localStorage 获取数据
  const storedData = localStorage.getItem(storageKey);
  let data = storedData ? JSON.parse(storedData) : null;

  if (!data) {
    // 第一次访问，初始化数据
    data = {
      startDate: new Date().toISOString(),
      lastShowDate: null,
      showCount: 0,
      totalDays: 30,
    };
    localStorage.setItem(storageKey, JSON.stringify(data));
  }

  // 检查是否已超过30天
  const startDate = new Date(data.startDate);
  const currentDate = new Date();
  const daysDiff = Math.floor(
    (currentDate - startDate) / (1000 * 60 * 60 * 24),
  );

  if (daysDiff >= data.totalDays) {
    return false; // 已超过30天，不再显示
  }

  // 检查今天是否已经显示过
  if (data.lastShowDate === today) {
    return false; // 今天已经显示过了
  }

  // 可以显示弹窗
  data.lastShowDate = today;
  data.showCount++;
  dayCount.value = data.showCount;
  localStorage.setItem(storageKey, JSON.stringify(data));

  return true;
};
const instance = ref(null);
onMounted(() => {
  const shouldShow = checkShouldShowModal();
  if (shouldShow) {
    dialogVisible.value = true;
  }
});
</script>

<style lang="scss" scoped>
.dialog-container {
  :deep(.el-dialog) {
    padding: 0;
    background-color: transparent;
    // .el-dialog__header {
    //   display: none;
    // }
    .el-dialog__body {
      background-color: transparent;
    }
    .fz {
      img {
        display: block;
        width: 981px;
        height: 420px;
      }
    }
    .close {
      text-align: right;
      margin: 8px 0;
      img {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
